module.exports = __webpack_public_path__ + "img/pe10.a2e4452f.jpg";